// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2TmeT","content":"ManualTimeModal_content__2vsuM"};